// utils/fetchWithAutoRefresh.js

/**
 * A drop-in replacement for fetch() that will automatically
 * refresh your JWT access cookie on a 401, then retry once.
 *
 * @param {string} url
 * @param {object} opts    fetch options (method, body, headers, etc.)
 * @param {function} onAuthError  called if the refresh also fails
 */

import { getCsrfToken } from './auth';

export async function fetchWithAutoRefresh(url, opts = {}, onAuthError = () => {}) {
  // 1) Always send cookies + CSRF header
  opts.credentials = 'include';
  opts.headers = {
    ...opts.headers,
    'X-CSRF-TOKEN': getCsrfToken()
  };

  // 2) Fire the original request
  let res = await fetch(url, opts);

  // 3) If we got a 401, try to refresh
  if (res.status === 401) {
    console.log('[auth] Access token expired, attempting refresh…');
    const refreshRes = await fetch(`/api/token/refresh`, {
      method:      'POST',
      credentials: 'include',
      headers:     { 'X-CSRF-TOKEN': getCsrfToken() }
    });

    if (refreshRes.ok) {
      console.log('[auth] Refresh succeeded, retrying original request');
      // re-read the fresh CSRF token that came back with the refresh
      opts.headers['X-CSRF-TOKEN'] = getCsrfToken();
      res = await fetch(url, opts);  // retry
    } else {
      console.warn('[auth] Refresh failed with status', refreshRes.status);
      onAuthError();  // e.g. clear context + redirect to login
      throw new Error('Session expired, please log in again');
    }
  }

  return res;
}
